import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'transactionDetail',
    label: 'Transaction Detail',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'constructionOrImprovementCosts',
    label: 'Construction/Improvement Cost',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'transactionDetailClosingType',
    label: 'Transaction Detail Closing Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'energyRelatedImprovementsIndicator',
    label: 'Energy Related Improvements',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'energyImprovementAmount',
    label: 'Improvement Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'amountOfEnergyEfficiencyMortgage',
    label: 'Amount of Energy Efficiency Mortgage',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'listOfEnergyImprovements',
    label: 'List of Energy Improvements',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const transactionDetailsForm = {
  name: FormNames.TRANSACTION_DETAILS,
  label: 'Transaction Details',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
